import type { ToastMessageOptions } from 'primevue/toast';

/**
 * Custom payload carried on a toast so `App.vue`'s `#message` slot can pick a template.
 *
 * PrimeVue 4's `ToastMessageOptions` has no `data` field, which is why `App.vue` needed a
 * `@ts-expect-error` to attach one. Typing it here removes the suppression.
 */
export interface AppToastData {
  type: 'push-notification' | 'app-error';
  [key: string]: unknown;
}

export interface AppToastMessage extends ToastMessageOptions {
  data?: AppToastData;
}

export const prepareToast = (
  severity: 'success' | 'info' | 'warn' | 'error' | 'secondary' | 'contrast' | undefined,
  summary: string,
  message: string,
  timeout: number = 3000
) : AppToastMessage => {
  return {
    severity,
    summary,
    detail: message,
    life: timeout
  };
};

export interface ErrorToastOptions {
  title: string;
  message: string;
  reference: string;
  canReport: boolean;
  /** Reportable failures stay until dismissed — three seconds is not long enough to react to one. */
  sticky?: boolean;
}

export const prepareErrorToast = (options: ErrorToastOptions): AppToastMessage => ({
  severity: 'error',
  summary: options.title,
  detail: options.message,
  // `life: undefined` is how PrimeVue is told not to auto-dismiss.
  life: options.sticky ? undefined : 6000,
  closable: true,
  data: {
    type: 'app-error',
    reference: options.reference,
    canReport: options.canReport
  }
});
